module.exports = __webpack_public_path__ + "static/media/07_NFP500A-5AX.1a0726c3.png";